export const getRandomEmoji = (cat, sub) => {

    let emojis = {
        'Smileys & Emotion': {
            'face-costume':['💩','🤡','👹','👺','👻','👽','👾','🤖'],
            'cat-face':['😺','😸','😹','😻','😼','😽','🙀','😿','😾'],
            'monkey-face':['🙈','🙉','🙊'],
        },
        'Animals & Nature': {
            'animal-mammal':['🐵','🐒','🦍','🦧','🐶','🐕','🦮','🐕‍🦺','🐩','🐺','🦊','🦝','🐱','🐈','🐈‍⬛','🦁','🐯','🐅','🐆','🐴','🐎','🦄','🦓','🦌','🦬','🐮','🐂','🐃','🐄','🐷','🐖','🐗','🐽','🐏','🐑','🐐','🐪','🐫','🦙','🦒','Browser','🐘','🦣','🦏','🦛','🐭','🐁','🐀','🐹','🐰','🐇','🐿','🦫','🦔','🦇','🐻','🐻‍❄️','🐨','🐼','🦥','🦦','🦨','🦘','🦡','🐾'],
            'animal-bird':['🦃','🐔','🐓','🐣','🐤','🐥','🐦','🐧','🕊','🦅','🦆','🦢','🦉','🦤','🪶','🦩','🦚','🦜'],
            'animal-amphibian':['🐸'],
            'animal-reptile':['🐊','🐢','🦎','🐍','🐲','🐉','🦕','🦖'],
            'animal-marine':['🐳','🐋','🐬','🦭','🐟','🐠','🐡','🦈','🐙','🐚','🪸'],
            'animal-bug':['🐌','🦋','🐛','🐜','🐝','🪲','🐞','🦗','🪳','🕷','🕸','🦂','🦟','🪰','🪱','🦠'],
            'plant-flower':['💐','🌸','💮','🪷','🏵','🌹','🥀','🌺','🌻','🌼','🌷'],
        },
    }

    const random = (array) => array[~~(Math.random() * array.length)]

    if(!emojis[cat])
        cat = random(Object.keys(emojis))

    if(!emojis[cat][sub])
        sub = random(Object.keys(emojis[cat]))

    return random(emojis[cat][sub])

}
